export default "__VITE_ASSET__BLNp3Bb$__"